
document.addEventListener( 'DOMContentLoaded', function () {
jQuery('.reviews_carousel').slick({
    arrows : false,
    dots : true,
    dotsClass : 'reviews__carousel_dots slick--dots',
    mobileFirst : true,
    centerMode: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000,
    fade: true,
});
} );


jQuery('.reviews_carousel').on('init', (event, slick) => {
    jQuery('.reviews__carousel_dots button').empty();
})